module.exports = __webpack_public_path__ + "static/media/header-button-1.5876548b.svg";